import { CircularProgress } from "@material-ui/core";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import i18next from "i18next";
import * as React from "react";

import { currencySymbol } from "../_constants";

import "../css/style.css";

export default function TicketDialog(props) {
  const [loading, setLoad] = React.useState(false);
  
  const [count, setCount] = React.useState(0);

  const { handleClose, tickets, dialogOpen } = props;

  React.useEffect(() => {});

  function cancelData() {
    handleClose(-1);
    setCount(0);
  }

  function selectTicket(id) {
    handleClose(id);
    setCount(0);
  }


  return (
    <Dialog open={dialogOpen}>
      <DialogTitle>{i18next.t("tickets_types")}</DialogTitle>
      <DialogContent style={{ minwidth: 300, maxWidth:600 }}>
        <div>
          {tickets.length > 0 &&
            tickets.map((item, index) => (
              <button
                className="btn-border"
                style={{ marginBottom: 10, minWidth: 250,maxWidth:400 }}
                onClick={() => selectTicket(item.id)}
              >
                <span>
                  {item.name}{item.cost>0 ? ", "+item.cost+" "+currencySymbol: ""}
                </span>
              </button>
            ))}
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={cancelData}>{i18next.t("close")}</Button>
      </DialogActions>
      {loading && (
        <div className="shadow">
          <div className="shadow_circle">
            <CircularProgress />
          </div>
        </div>
      )}
    </Dialog>
  );
}
